"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function detectSkill(text) {
    if (/^\[\[(.*?)\]\]$/.test(text)) {
        return RegExp.$1;
    }
    return null;
}
exports.detectSkill = detectSkill;
exports.Skill = function (_a) {
    var src = _a.src, id = _a.id, token = _a.token;
    var _b = react_1.default.useState(0), height = _b[0], setHeight = _b[1];
    react_1.default.useEffect(function () {
        var f = function (_a) {
            var data = _a.data;
            if (data.__krkr__ && data._id === id && data.type === 'resize') {
                // console.log(data)
                setHeight(data.height);
            }
        };
        window.addEventListener('message', f);
        return function () {
            window.removeEventListener('message', f);
        };
    }, []);
    var $skill = react_1.default.useRef(null);
    var handleSkillLoad = function () {
        var _a, _b, _c;
        (_c = (_b = (_a = $skill) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.contentWindow) === null || _c === void 0 ? void 0 : _c.postMessage({
            type: 'init',
            _id: id,
            // next: data.skill.next,
            // customer,
            // params,
            skillParams: {
                token: token
            }
        }, '*');
    };
    var skillStyle = { display: 'block', border: 'none', width: '100%', height: height };
    return (react_1.default.createElement("iframe", { src: src, style: skillStyle, 
        // className={classes.iframe}
        onLoad: handleSkillLoad, ref: $skill, scrolling: "no" }));
};
//# sourceMappingURL=Skill.js.map